import * as am4core from "@amcharts/amcharts4/core"

export function disableInteraction(template: am4core.Sprite): void {
  template.clickable = false
  template.focusable = false
  template.cursorOverStyle = am4core.MouseCursorStyle.default
}
